import { LinearGradient } from "expo-linear-gradient";
import React from "react";

import { OrderItemQualityEnum } from "@/interfaces/domain/Order";

import {
  BolaMenor,
  ButtonGrauMadureza,
  Container,
  TextGrauMadureza,
  ViewButtonsGrauMadureza,
  ViewGrausMadureza,
  ViewTextsGrauMadureza,
} from "./styles";

type MatureGradeBarProps = {
  selectedQuality?: OrderItemQualityEnum | null;
  handleSelectQuality: (quality: OrderItemQualityEnum) => void;
};

const MatureGradeBar = ({ selectedQuality, handleSelectQuality }: MatureGradeBarProps) => {
  const isGreen = selectedQuality === OrderItemQualityEnum.GREEN;
  const isNormal = !selectedQuality || selectedQuality === OrderItemQualityEnum.NORMAL;
  const isMature = selectedQuality === OrderItemQualityEnum.MATURE;

  return (
    <Container>
      <LinearGradient
        colors={["#52BF1B", "#ff8c00"]}
        style={{ height: 5 }}
        start={[0, 0]}
        end={[1, 0]}
      />
      <ViewGrausMadureza>
        <ViewTextsGrauMadureza>
          <TextGrauMadureza isGreen={isGreen}>Verde</TextGrauMadureza>
          <TextGrauMadureza isNormal={isNormal}>Normal</TextGrauMadureza>
          <TextGrauMadureza isMature={isMature}>Maduro</TextGrauMadureza>
        </ViewTextsGrauMadureza>
        <ViewButtonsGrauMadureza>
          <ButtonGrauMadureza
            onPress={() => handleSelectQuality(OrderItemQualityEnum.GREEN)}
            isGreen={isGreen}>
            <BolaMenor isGreen={isGreen} />
          </ButtonGrauMadureza>
          <ButtonGrauMadureza
            onPress={() => handleSelectQuality(OrderItemQualityEnum.NORMAL)}
            isNormal={isNormal}>
            <BolaMenor isNormal={isNormal} />
          </ButtonGrauMadureza>
          <ButtonGrauMadureza
            onPress={() => handleSelectQuality(OrderItemQualityEnum.MATURE)}
            isMature={isMature}>
            <BolaMenor isMature={isMature} />
          </ButtonGrauMadureza>
        </ViewButtonsGrauMadureza>
      </ViewGrausMadureza>
    </Container>
  );
};

export default MatureGradeBar;
